import { motion } from 'framer-motion';
import { FiArrowRight } from 'react-icons/fi';

const WelcomeStep = ({ onNext }) => {
  return (
    <motion.div 
      className="onboarding-step welcome-step"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
    >
      <div className="welcome-content">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
        >
          Welcome to The Basics
        </motion.h2>
        
        <motion.p 
          className="welcome-description"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
        >
          Your journey to a more balanced and organized life starts here.
        </motion.p>

        <motion.div 
          className="welcome-features"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4 }}
        >
          <div className="feature-item">
            <span className="feature-emoji">🎯</span>
            <span>Track Goals</span>
          </div>
          <div className="feature-item">
            <span className="feature-emoji">🧘‍♂️</span>
            <span>Monitor Wellness</span>
          </div>
          <div className="feature-item">
            <span className="feature-emoji">📈</span>
            <span>Grow Daily</span>
          </div>
        </motion.div>

        <motion.button 
          className="onboarding-btn"
          onClick={onNext}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5 }}
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
        >
          Get Started <FiArrowRight />
        </motion.button>
      </div>
    </motion.div>
  );
};

export default WelcomeStep; 